import { ThemeProvider } from "@emotion/react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { FormGroup, Input } from "reactstrap";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createTheme } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import { normalization } from "../utils/utils";

export function TextSchema({
  label,
  onTextInputChange,
  textValue,
  placeholderValue,
  required,
  name,
}) {
  return (
    <FormGroup className="mb-2">
      <label className="block mt-3 outer-textlab">
        {label === "certificate_id" ? (
          <>Certificate ID</>
        ) : (
          <>
            {normalization(label)}{" "}
            {required && <span className="text-danger">*</span>}
          </>
        )}
      </label>

      <Input
        type="text"
        name={name}
        placeholder={placeholderValue}
        onChange={onTextInputChange}
        value={textValue || ""}
        autoComplete="on"
      />
    </FormGroup>
  );
}

export function NumberSchema({
  label,
  onTextInputChange,
  textValue,
  placeholderValue,
  required,
  name,
}) {
  return (
    <FormGroup className="mb-2">
      <label className="block mt-3 outer-textlab">
        {label} {required && <span className="text-danger">*</span>}
      </label>

      <Input
        type="number"
        name={name}
        placeholder={placeholderValue}
        onChange={onTextInputChange}
        value={textValue || ""}
      />
    </FormGroup>
  );
}

export function FileSchema({ label, onFileChange, required, name, accept }) {
  return (
    <FormGroup className="mb-2">
      <label className="block mt-3 outer-textlab">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <Input
        className="form-control"
        lang="en"
        type="file"
        name={name}
        accept={accept}
        onChange={onFileChange}
        autoComplete="on"
      />
    </FormGroup>
  );
}

export function DatePicker({
  label,
  onChange,
  required,
  selected,
  format,
  name,
}) {
  const [open, setOpen] = useState(false);
  const materialTheme = createTheme({
    components: {
      MuiPickersToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: "#40172fbf",
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            color: "#ffffff !important",
          },
          h4: {
            color: "#ffffff",
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: "#0a2f41 !important",
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          textPrimary: {
            color: "#3f51b5",
          },
        },
      },
    },
  });
  const renderInput = (props) => {
    const { inputRef, onChange } = props;

    return (
      <FormGroup className="mb-2">
        <label className="block mt-3 outer-textlab">
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
        <Input
          type="text"
          name={name}
          onClick={() => setOpen(true)}
          value={selected ? dayjs(selected).format("D MMM YYYY") : ""}
          onChange={onChange}
          variant="inline"
          autoComplete="on"
          placeholder={
            selected ? dayjs(selected).format("D MMM YYYY") : "Select Date"
          }
        />
      </FormGroup>
    );
  };

  return (
    <ThemeProvider theme={materialTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          format={format ? format : "d MMM YYYY"}
          onChange={onChange}
          name={name}
          value={selected ? dayjs(selected) : dayjs()}
          open={open}
          closeOnSelect={true}
          orientation="portrait"
          autocomplete="on"
          slots={{
            field: (slotProps) => renderInput(slotProps),
          }}
          placeholder={selected ? selected : "Select Date"}
          sx={{ border: 0, borderColor: "blue" }}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
